import { BorderColorType } from "@/lib/main";
import { CSSProperties } from "react";

type Props = {
  color?: BorderColorType;
  style?: CSSProperties;
};

export default function HR({ color, style }: Props) {
  const styles: CSSProperties = {
    border: "none",
    borderTop: `var(--border-width-xs) solid var(--color-border-${
      color || "subtle"
    })`,
    width: "100%",
    ...style,
  };

  return <hr style={styles} />;
}
